import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from 'src/UI/Icon/Icon';

const HeaderWrapper = styled.div`
  width: 100%;
`;

const headerOpacityOverlayHeight = 60;
const styledHeaderHeight = 60;
export const headerHeight = headerOpacityOverlayHeight + styledHeaderHeight;

const HeaderOpacityOverlay = styled.div`
  position: relative;
  z-index: 2;
  height: ${headerOpacityOverlayHeight}px;
  background: rgba(255, 255, 255, 0.7);
`;

const StyledHeader = styled.div`
  position: relative;
  z-index: 1;
  height: ${styledHeaderHeight}px;
  background: #fff;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  font-weight: 600;
  font-size: 14px;
`;

const CloseButton = styled.button`
  position: absolute;
  right: 0;
  background: transparent;
  border: none;
  cursor: pointer;
`;

const CloseText = styled.span`
  vertical-align: middle;
  margin-right: 8px;
`;

const Header = ({ onClose, title, closeText }) => {
  return (
    <HeaderWrapper>
      <HeaderOpacityOverlay />
      <StyledHeader>
        <span>{title}</span>
        <CloseButton onClick={onClose}>
          <CloseText>{closeText}</CloseText>
          <Icon name="cross" color="#000" size="medium" />
        </CloseButton>
      </StyledHeader>
    </HeaderWrapper>
  );
};

Header.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  closeText: PropTypes.string.isRequired
};

export default Header;
